import { classnames } from '@aibees/shared/utils';
import { TabContext, TabList } from '@mui/lab';
import { Tab, Tooltip } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { cloneElement, memo, useState } from 'react';
import { Grid2 } from '../grid-2';
import * as Styled from './styles';
import * as SX from './sx';
import type {
  SettingsPageTabsProps as Props,
  SettingsPageTabConfig,
} from './types';

export const SettingPageTabs = memo(
  ({ className, config, onChange, tabsContainerSx }: Props) => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const activeTab = config?.[activeTabIndex];
    const activeComponent = activeTab?.component;
    const activeExtra = activeTab?.extra;

    const handleSwitchTab = (tabIndex: number) => {
      const tab = config?.[tabIndex];
      if (!tab?.comingSoon) {
        setActiveTabIndex(tabIndex);
        onChange?.(tab as SettingsPageTabConfig);
      }
    };

    return (
      <TabContext value={activeTabIndex}>
        <Styled.Wrapper
          className={classnames('SettingPageTabs', className)}
          sx={SX.root}
        >
          <Grid2
            direction="row"
            justifyContent={'space-between'}
            alignItems={'end'}
            sx={mergeSx(SX.tabsContainer, tabsContainerSx)}
          >
            <TabList variant="standard" onChange={(e, v) => handleSwitchTab(v)}>
              {config?.map((tab, index) => {
                const content = (
                  <Tab
                    key={tab.title}
                    label={tab.title}
                    value={index}
                    disabled={tab.comingSoon}
                  />
                );
                if (tab.comingSoon)
                  return (
                    <Tooltip
                      key={tab.title}
                      title={tab.comingSoon && 'Coming Soon'}
                      placement="top"
                    >
                      <span>{content}</span>
                    </Tooltip>
                  );

                return content;
              })}
            </TabList>
            <Grid2>{activeExtra}</Grid2>
          </Grid2>

          {activeComponent &&
            cloneElement(activeComponent, {
              ...activeComponent.props,
              key: activeTabIndex,
            })}
        </Styled.Wrapper>
      </TabContext>
    );
  }
);

SettingPageTabs.displayName = 'SettingPageTabs';
